import { NumericRange } from '../types';

/** @returns the absolute value of the difference between min and max. */
export const range = ([min, max]: NumericRange): number => Math.abs(min - max);
/** @returns the portion of `value` within `domain`, expressed as a value between zero and one  */
export const normalize = (domain: NumericRange, value: number): number =>
  (value - domain[0]) / range(domain) || 0; // if domain has zero range, adjust NaN to 0
/** @returns the real value of `normalizedValue` within `domain`, expressed in domain units. */
export const denormalize = (domain: NumericRange, normalizedValue: number) =>
  normalizedValue * range(domain) + domain[0];
